import { render, staticRenderFns } from "./spareParts.vue?vue&type=template&id=bd857256&scoped=true"
import script from "./spareParts.vue?vue&type=script&lang=js"
export * from "./spareParts.vue?vue&type=script&lang=js"
import style0 from "./spareParts.vue?vue&type=style&index=0&id=bd857256&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd857256",
  null
  
)

export default component.exports